export const Actions = {
  RequestResetPasswordLink: "requestResetPasswordLink",
  ResetPassword: "resetPassword",
  RequestEmailValidationLink: "requestEmailValidationLink",
  ValidateEmail: "validateEmail",
  CheckScheduledTasks: "checkScheduledTasks",
  RequestClientAccess: "requestClientAccess",
  AcceptVisitMandate: "acceptVisitMandate",
};
